import React from 'react';
import {mainFirebase} from '../../firebase-config';
import "./../top-recipe-bar/style.scss";

class RecipeList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            uiHandler: []
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.querySnapshot !== this.props.querySnapshot){
            this.getPropsData();
        }
    }

    getPropsData = () => {
        this.props.querySnapshot.forEach(async (doc) => {
            const uiHandler = []
            const imgURL = await this.getImage(doc.data().image_filename);
            let rtype = 'Breakfast';
            if(doc.data().rtype === '2'){
                rtype = 'Lunch';
            } else if (doc.data().rtype === '3'){
                rtype = 'Dinner'
            } else if (doc.data().rtype === '4') {
                rtype = 'Snacks'
            }
            uiHandler.push((
                <div className='col-lg-4 col-md-4 animate-top'>
                    <div className='side-card'>
                        <div className="card__tag-wrapper">
                            <span className="card__triangle"></span>
                                <p className="card__tag">
                                    {rtype}
                                </p> 
                            <span className="card__triangle--flipped"></span>
                        </div>
                        <img src={imgURL} alt="" className='side-image' />
                        <div className='side-card-container'>
                            <h4><a href={"/recipe-detail/" + doc.id}>{doc.data().title}</a></h4>
                        </div>
                    </div>
                </div>
            ))
            this.setState({uiHandler: [...this.state.uiHandler, uiHandler]})
        });
    }

    getImage = async filename => {
        if(filename){
            const storageRef = mainFirebase.storage().ref();
            return await storageRef.child(`recipe_image/${filename}`).getDownloadURL()
        }
    }

    loadMore = e => {
        e.preventDefault();
        this.props.loadMore();
    }

    render(){
        return(
            <div className="top">
                <div className="container">
                    <div className='main-title'>
                        <div className='main-title-sub'>
                            <i className="fa fa-cutlery" aria-hidden="true"></i> 
                            <a href="/recipe">Recipes >>></a>
                        </div>
                    </div>
                    <div className="row mt-3">
                        {this.state.uiHandler}
                    </div>
                </div>
            </div>
        )
    }
}

export default RecipeList;